import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'otherActivity';

const otherActivityService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  updateData: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createData: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteData: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
    });
  },

  orderData: (id, data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/orderData/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default otherActivityService;
